<template>
  <div>
    <h2 class="custom-title-secondary"
      >Não foi possível concluir a transação</h2
    >
    <p class="custom-normal-text font-weight-medium "
      >Confira abaixo os possíveis problemas:</p
    >
    <ul class="scustom-normal-text">
      <li
        >Verifique se todos os dados do cartão de crédito foram digitados
        corretamente e tente novamente;</li
      >
      <li
        >Entre em contato com o banco emissor deste cartão de crédito e
        verifique se existe alguma restrição para finalizar a compra;</li
      >
      <li
        >Escolha outros meios de pagamento (outro cartão de crédito ou boleto
        bancário).</li
      >
    </ul>
    <v-btn class="custom-btn-green" @click="roolbackPayment()"
      >Voltar para a página de pagamento</v-btn
    >
  </div>
</template>

<script>
import { STEP_PAYMENT_INFO } from '@state/modules/payment-info'
import { paymentMethods } from '@state/helpers'

export default {
  name: 'payment-bill-creditcard-fail',
  data() {
    return {}
  },
  methods: {
    ...paymentMethods,
    roolbackPayment() {
      this.saveCompanyPaymentInfoField({
        step: STEP_PAYMENT_INFO,
        idPaymentsType: null,
        creditCardLastNumbers: null,
        creditCardTokenIugu: null,
        boletoLink: null,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@design';
</style>
